import { Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Field } from '../../models/field.interface';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'ft-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.css'],
    imports: [
        MatFormField,
        FormsModule,
        ReactiveFormsModule,
        MatLabel,
        MatInput,
    ]
})
export class FormInputComponent implements Field {
	config: any;
	group: FormGroup;

	constructor() {}
}
